export default {
	default: [''],
	leftLabel: ['radio-group--left-label']
};
